// Adaptador concreto del repositorio de riesgos consultables
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ConsultableRisksRepository } from '../../../domain/repositories/consultable-risks/consultable-risks.repository';
import {
  ConsultableRisksInput,
  ConsultableRisksPersonInput,
  ConsultableRisksResult,
} from '../../../domain/interfaces/consultable-risks/consultable-risks.interface';
import { HttpClientService } from '../../services/http-client/http-client.service';
import { API_ENDPOINTS } from '../../config/api.config';

interface ConsultableRisksPersonDto {
  id_type: string;
  id_number: string;
}

interface ConsultableRisksRequestDto {
  productFamily: string;
  leadId: string;
  data: {
    placa: string;
    tomador: ConsultableRisksPersonDto;
    asegurado: ConsultableRisksPersonDto;
  };
}

interface ConsultableRiskRecordDto {
  idRegistroValidacion: string;
  mensajeValidacion: string;
  tipoValidacion: string;
  esRiesgo: boolean;
}

interface ConsultableRisksResponseDto {
  success: boolean;
  data: ConsultableRiskRecordDto[];
}


function toPersonDto(person: ConsultableRisksPersonInput): ConsultableRisksPersonDto {
  return { id_type: person.documentType, id_number: person.documentNumber };
}

@Injectable()
export class ConsultableRisksRepositoryImplementation extends ConsultableRisksRepository {
  private readonly http = inject(HttpClientService);

  override check(input: ConsultableRisksInput): Observable<ConsultableRisksResult> {
    const dto: ConsultableRisksRequestDto = {
      productFamily: input.productFamily,
      leadId: input.leadId,
      data: {
        placa: input.placa,
        tomador: toPersonDto(input.tomador),
        asegurado: toPersonDto(input.asegurado),
      },
    };

    return this.http
      .postRaw<ConsultableRisksResponseDto>(API_ENDPOINTS.consultableRisks.check, dto)
      .pipe(map((response) => this.toResult(response)));
  }

  private toResult(dto: ConsultableRisksResponseDto): ConsultableRisksResult {
    return {
      success: dto.success,
      records: dto.data.map((record) => ({
        validationId: record.idRegistroValidacion,
        validationMessage: record.mensajeValidacion,
        validationType: record.tipoValidacion,
        isRisk: record.esRiesgo,
      })),
    };
  }
}
